import { render, staticRenderFns } from "./benefitclaimfrm.vue?vue&type=template&id=87fe3688"
import script from "./benefitclaimfrm.vue?vue&type=script&lang=js"
export * from "./benefitclaimfrm.vue?vue&type=script&lang=js"
import style0 from "./benefitclaimfrm.vue?vue&type=style&index=0&id=87fe3688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports